import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatExpireTimestamp(seconds: number) {
  return Date.now() + seconds * 1000
}

export function toNumber(value: unknown, fallback = 0): number {
  if (typeof value === 'number') return Number.isFinite(value) ? value : fallback
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed) return fallback
    const parsed = Number(trimmed)
    return Number.isFinite(parsed) ? parsed : fallback
  }
  return fallback
}

export function toStringId(value: string | number | null | undefined): string {
  return value == null ? '' : String(value).trim()
}
